module.exports = __webpack_public_path__ + "static/media/appleTv.c77a670b.png";